// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"5df7ea1c","453":"e2e6b784","551":"748977fd","578":"900c02e1","640":"4f7c5345"}[chunkId] + ".chunk.js";
};